/**
 * Phone Utils
 * Helpers for cleaning and formatting phone numbers with country codes
 */

export const COUNTRIES = [
  { code: "US", name: "USA", dial_code: "+1", flag: "🇺🇸", limit: 10 },
  { code: "CA", name: "Canada", dial_code: "+1", flag: "🇨🇦", limit: 10 },
  { code: "PT", name: "Portugal", dial_code: "+351", flag: "🇵🇹", limit: 9 },
  { code: "DE", name: "Germany", dial_code: "+49", flag: "🇩🇪", limit: 11 },
  { code: "GB", name: "UK", dial_code: "+44", flag: "🇬🇧", limit: 10 },
  { code: "TR", name: "Turkey", dial_code: "+90", flag: "🇹🇷", limit: 10 },
  { code: "FR", name: "France", dial_code: "+33", flag: "🇫🇷", limit: 9 },
  { code: "IT", name: "Italy", dial_code: "+39", flag: "🇮🇹", limit: 10 },
  { code: "ES", name: "Spain", dial_code: "+34", flag: "🇪🇸", limit: 9 },
  { code: "NL", name: "Netherlands", dial_code: "+31", flag: "🇳🇱", limit: 9 },
  { code: "BE", name: "Belgium", dial_code: "+32", flag: "🇧🇪", limit: 9 },
  { code: "AT", name: "Austria", dial_code: "+43", flag: "🇦🇹", limit: 13 },
  { code: "CH", name: "Switzerland", dial_code: "+41", flag: "🇨🇭", limit: 9 },
  { code: "SE", name: "Sweden", dial_code: "+46", flag: "🇸🇪", limit: 9 },
  { code: "NO", name: "Norway", dial_code: "+47", flag: "🇳🇴", limit: 8 },
  { code: "DK", name: "Denmark", dial_code: "+45", flag: "🇩🇰", limit: 8 },
  { code: "FI", name: "Finland", dial_code: "+358", flag: "🇫🇮", limit: 10 },
  { code: "IE", name: "Ireland", dial_code: "+353", flag: "🇮🇪", limit: 9 },
  { code: "PL", name: "Poland", dial_code: "+48", flag: "🇵🇱", limit: 9 },
  { code: "GR", name: "Greece", dial_code: "+30", flag: "🇬🇷", limit: 10 }
];

/**
 * Get digits only from a string
 * @param {string} value
 * @returns {string} digits only
 */
export const cleanDigits = (value) => {
  if (!value) return "";
  return value.toString().replace(/\D/g, "");
};

/**
 * Get country object by ISO code
 * @param {string} code
 * @returns {object} country object
 */
export const getCountryByCode = (code) => {
  return COUNTRIES.find((c) => c.code === code) || COUNTRIES[0];
};

/**
 * Parse a full phone number into country and digits
 * @param {string} phone
 * @returns {object} { country, digits }
 */
export const parsePhone = (phone) => {
  if (!phone) return { country: COUNTRIES[0], digits: "" };

  // Sort by dial_code length desc to match longest prefix first
  const sorted = [...COUNTRIES].sort(
    (a, b) => b.dial_code.length - a.dial_code.length
  );

  for (const country of sorted) {
    if (phone.startsWith(country.dial_code)) {
      const digits = phone.slice(country.dial_code.length);
      return { country, digits: cleanDigits(digits) };
    }
  }

  // Handle case where phone might start with + or 1 without +
  if (phone.startsWith("1") && phone.length > 10) {
    return { country: COUNTRIES[0], digits: cleanDigits(phone.slice(1)) };
  }

  return { country: COUNTRIES[0], digits: cleanDigits(phone) };
};
